import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import LearnNavBar from './components/LearnNavBar';
import LandingPage from './pages/LandingPage';
import TrianglePage from './pages/TrianglePage';
import QuizPage from './pages/QuizPage';
import PlannerPage from './pages/PlannerPage';
import FredPage from './pages/FredPage';
import ChatPage from './pages/ChatPage';
import ProcessPage from './pages/ProcessPage';
import ShelfPage from './pages/ShelfPage';
import ExplainersPage from './pages/ExplainersPage';
import ReadingNotesPage from './pages/ReadingNotesPage';
import Footer from './components/Footer';
import { Analytics } from '@vercel/analytics/react';
import { CLERK_CONFIGURED } from './lib/clerkConfig';
import { isLearnSubdomain } from './lib/subdomain';
import LmsComingSoonPage from './pages/LmsComingSoonPage';
import LearnPage from './pages/LearnPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LessonPage from './pages/LessonPage';
import MyLearningPage from './pages/MyLearningPage';
import CapstonePage from './pages/CapstonePage';
import ReviewPage from './pages/ReviewPage';
import ReadingsPage from './pages/ReadingsPage';
import CertificatePage from './pages/CertificatePage';
import VerifyCertificatePage from './pages/VerifyCertificatePage';

// learn.austrianprocess.com is a distinct experience within the same app --
// its own nav, its own top-level (unprefixed) routes, no marketing content.
// The main site's old /learn/* paths become real HTTP redirects to this
// subdomain at the Vercel config level (vercel.json), not React routes, so
// they never reach this component -- see vercel.json for those rules.
function LearnApp() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 1 }}>
      <LearnNavBar />
      <main className="app-main" style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={CLERK_CONFIGURED ? <LearnPage /> : <LmsComingSoonPage />} />
          <Route path="/my-learning" element={CLERK_CONFIGURED ? <MyLearningPage /> : <LmsComingSoonPage />} />
          <Route path="/capstone" element={CLERK_CONFIGURED ? <CapstonePage /> : <LmsComingSoonPage />} />
          {/* Static segment, so it outranks /:courseSlug regardless of order
              (React Router ranks static above dynamic). Access is enforced by
              the backend, not by this route existing -- see ADR-0005. */}
          <Route path="/review" element={CLERK_CONFIGURED ? <ReviewPage /> : <LmsComingSoonPage />} />
          {/* Public: the reading list is part of the pitch, not gated behind sign-in. */}
          <Route path="/readings" element={<ReadingsPage />} />
          <Route path="/certificate" element={CLERK_CONFIGURED ? <CertificatePage /> : <LmsComingSoonPage />} />
          {/* Public, and unauthenticated on purpose: a credential nobody
              outside the site can check is not worth issuing (ADR-0009). */}
          <Route path="/verify" element={<VerifyCertificatePage />} />
          <Route path="/verify/:code" element={<VerifyCertificatePage />} />
          <Route path="/:courseSlug" element={CLERK_CONFIGURED ? <CourseDetailPage /> : <LmsComingSoonPage />} />
          <Route path="/:courseSlug/:lessonSlug" element={CLERK_CONFIGURED ? <LessonPage /> : <LmsComingSoonPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}

function MainApp() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 1 }}>
      <NavBar />
      <main className="app-main" style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/garrison-triangle" element={<TrianglePage />} />
          <Route path="/calculation-problem" element={<PlannerPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/ask-austrian" element={<ChatPage />} />
          <Route path="/shelf" element={<ShelfPage />} />
          <Route path="/fred" element={<FredPage />} />
          <Route path="/explainers" element={<ExplainersPage />} />
          <Route path="/reading-notes" element={<ReadingNotesPage />} />

          {/* Backward compatibility redirects */}
          <Route path="/triangle" element={<Navigate to="/garrison-triangle" replace />} />
          <Route path="/planner" element={<Navigate to="/calculation-problem" replace />} />
          <Route path="/ask" element={<Navigate to="/ask-austrian" replace />} />
          <Route path="/chat" element={<Navigate to="/ask-austrian" replace />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}

function App() {
  return isLearnSubdomain() ? <LearnApp /> : <MainApp />;
}

export default App;
